import { Link, useNavigate } from "react-router-dom";
import { formatCurrency, formatPaidAt, formatPaymentMonth } from "./dashboardUtils";

export default function RecentPayments({ payments = [] }) {
  const navigate = useNavigate();

  return (
    <section className="rounded-2xl bg-white p-4 shadow sm:p-5">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-zinc-950">
            Recent Successful Payments
          </h3>
          <p className="text-sm text-zinc-500">
            Receipt links for your latest successful payments.
          </p>
        </div>
        <Link
          to="/transactions"
          className="text-sm font-semibold text-emerald-700 hover:text-emerald-900"
        >
          View all transactions
        </Link>
      </div>

      {!payments.length ? (
        <div className="mt-4 rounded-xl bg-zinc-50 p-4 text-sm text-zinc-500">
          No successful payments found for this year yet.
        </div>
      ) : (
        <>
          <div className="mt-4 hidden overflow-x-auto md:block">
            <table className="min-w-full text-sm">
              <thead className="border-y bg-zinc-50 text-left text-zinc-500">
                <tr>
                  <th className="px-4 py-3 font-medium">Payment Month</th>
                  <th className="px-4 py-3 font-medium">Paid At</th>
                  <th className="px-4 py-3 text-right font-medium">Amount</th>
                  <th className="px-4 py-3 text-right font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment) => (
                  <tr
                    key={payment.paymentId}
                    className="cursor-pointer border-b hover:bg-zinc-50"
                    onClick={() => navigate(payment.receiptPath)}
                  >
                    <td className="px-4 py-3">
                      {formatPaymentMonth(payment.paymentMonth)}
                    </td>
                    <td className="px-4 py-3">{formatPaidAt(payment.paymentDate)}</td>
                    <td className="px-4 py-3 text-right font-semibold text-emerald-700">
                      {formatCurrency(payment.amount)}
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className="rounded-full bg-emerald-100 px-2 py-1 text-xs font-semibold text-emerald-700">
                        {payment.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4 space-y-3 md:hidden">
            {payments.map((payment) => (
              <button
                type="button"
                key={payment.paymentId}
                onClick={() => navigate(payment.receiptPath)}
                className="w-full rounded-xl bg-zinc-50 p-3 text-left"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-semibold text-zinc-900">
                      {formatPaymentMonth(payment.paymentMonth)}
                    </p>
                    <p className="text-xs text-zinc-500">
                      {formatPaidAt(payment.paymentDate)}
                    </p>
                  </div>
                  <p className="font-semibold text-emerald-700">
                    {formatCurrency(payment.amount)}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
